import { useState } from "react";
import { useFeedback } from "../../context/FeedbackContext";
import "./Feedback.css";

// const FeedbackPage = () => {
//   const { sendFeedback } = useFeedback();

//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     description: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (form.description.length < 20) {
//       alert("Description must be at least 20 characters");
//       return;
//     }

//     try {
//       setLoading(true);

//       await sendFeedback(form);

//       alert("✅ Feedback submitted!");

//       // reset form
//       setForm({
//         firstName: "",
//         lastName: "",
//         email: "",
//         description: "",
//       });
//     } catch (err) {
//       alert("❌ Failed to submit feedback");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="feedback-container">
//       <h2 className="feedback-title">Feedback</h2>

//       <form className="feedback-form" onSubmit={handleSubmit}>
//         <input
//           className="feedback-input"
//           type="text"
//           name="firstName"
//           placeholder="First Name"
//           value={form.firstName}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="feedback-input"
//           type="text"
//           name="lastName"
//           placeholder="Last Name"
//           value={form.lastName}
//           onChange={handleChange}
//           required
//         />

//         <input
//           className="feedback-input"
//           type="email"
//           name="email"
//           placeholder="Email"
//           value={form.email}
//           onChange={handleChange}
//           required
//         />

//         <textarea
//           className="feedback-input feedback-textarea"
//           name="description"
//           placeholder="Write your feedback..."
//           value={form.description}
//           onChange={handleChange}
//           minLength={20}
//           required
//         />

//         <button className="feedback-btn" type="submit" disabled={loading}>
//           {loading ? "Submitting..." : "Submit Feedback"}
//         </button>
//       </form>
//     </div>
//   );
// };

const FeedbackPage = () => {
  const { sendFeedback } = useFeedback();
  const [files, setFiles] = useState([]);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    // Cap at 5 files, 5MB each
    const valid = selected.filter((f) => f.size <= 5 * 1024 * 1024);
    setFiles((prev) => [...prev, ...valid].slice(0, 5));
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.description.length < 20) {
      setError("Description must be at least 20 characters.");
      return;
    }

    try {
      setLoading(true);
      await sendFeedback(form);
      setSubmitted(true);
      await sendFeedback(form, files);
      setFiles([]);
      setForm({ firstName: "", lastName: "", email: "", description: "" });
    } catch (err) {
      setError("Failed to submit feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="fb-page">
        <div className="fb-wrap">
          <div className="fb-success-card">
            <div className="fb-success-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#16A34A"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h2>Feedback submitted</h2>
            <p>
              Thanks for helping us improve QuantKubera. We read every message.
            </p>
            <button
              className="fb-btn-secondary"
              onClick={() => setSubmitted(false)}
            >
              Send another
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fb-page">
      <div className="fb-wrap">
        <div className="fb-header">
          <div className="fb-icon-wrap">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#4F6EF7"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h2>Share your feedback</h2>
          <p>
            Help us improve QuantKubera. Tell us what's working, what's broken,
            or what you'd like to see next.
          </p>
        </div>

        <form className="fb-card" onSubmit={handleSubmit}>
          <div className="fb-row">
            <div className="fb-field">
              <label htmlFor="fb-firstName">First name</label>
              <input
                id="fb-firstName"
                type="text"
                name="firstName"
                placeholder="John"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="fb-field">
              <label htmlFor="fb-lastName">Last name</label>
              <input
                id="fb-lastName"
                type="text"
                name="lastName"
                placeholder="Doe"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="fb-field-full">
            <label htmlFor="fb-email">Email</label>
            <input
              id="fb-email"
              type="email"
              name="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="fb-field-full">
            <label htmlFor="fb-description">Your feedback</label>
            <textarea
              id="fb-description"
              name="description"
              placeholder="Tell us what you think — feature requests, bugs, or general thoughts..."
              value={form.description}
              onChange={handleChange}
              minLength={20}
              required
            />
            <span className="fb-hint">Minimum 20 characters</span>
          </div>
          <div className="fb-field-full">
            <label>Attachments (optional)</label>
            <div className="fb-dropzone">
              <input
                type="file"
                multiple
                accept="image/png,image/jpeg,image/webp,application/pdf"
                onChange={handleFileChange}
                id="fb-files"
                className="fb-file-input"
              />
              <label htmlFor="fb-files" className="fb-dropzone-label">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
                Click to upload — PNG, JPEG, WebP, or PDF (max 5MB each)
              </label>
            </div>

            {files.length > 0 && (
              <ul className="fb-file-list">
                {files.map((f, i) => (
                  <li key={i}>
                    <span>{f.name}</span>
                    <button type="button" onClick={() => removeFile(i)}>
                      ✕
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {error && <div className="fb-error">{error}</div>}

          <button type="submit" className="fb-submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit feedback"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;
